var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 392,
    height: 130,
    viewBox: "0 0 392 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23309 3793)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 392,
    height: 130,
    transform: "translate(-23309 -3793)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23462.924 -4033.876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.643,276.3h26.118L188.4,303.38h4.261l16.358-27.08h26.255l-16.22,27.08H237.2l-7.285,12.1H211.634L225.93,335H199.675l-14.159-19.52H180.98L195.139,335h-25.98L155,315.476Z",
    transform: "translate(0 0)",
    fill: "#033572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7,322.3h7.973V306.494h14.846V322.3h8.11V285.6h-8.11v14.159H245.673V285.6H237.7Z",
    transform: "translate(30.981 3.484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.232,309.408c0,1.65-.137,6.048-5.911,6.048-2.337,0-4.4-.687-4.4-3.437,0-2.612,2.062-3.437,4.261-3.849s4.811-.412,6.048-1.512v2.749Zm-9.485-8.11c.275-2.887,2.062-3.986,4.811-3.986,2.612,0,4.674.412,4.674,3.574,0,3.024-4.124,2.887-8.66,3.437s-9.072,2.062-9.072,8.11c0,5.5,3.986,7.973,9.072,7.973,3.3,0,6.6-.825,8.935-3.3a8.875,8.875,0,0,0,.55,2.612h7.423c-.687-1.1-.962-3.437-.962-5.911V300.06c0-6.323-6.323-7.56-11.684-7.56-5.911,0-12.1,2.062-12.509,8.935h7.423Z",
    transform: "translate(39.896 6.069)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.4,329.1h7.285V316.456h.137a9.529,9.529,0,0,0,7.973,3.986c7.7,0,11.684-6.6,11.684-13.746,0-7.56-3.711-14.3-12.1-14.3a8.853,8.853,0,0,0-7.973,4.124h-.137v-3.3H281.4V329.1Zm13.471-14.158c-4.674,0-6.323-4.124-6.323-8.385s1.512-8.523,6.323-8.523c4.674,0,6.323,4.4,6.323,8.523,0,4.4-1.512,8.385-6.323,8.385Z",
    transform: "translate(47.351 6.031)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.57,309.408c0,1.65-.137,6.048-5.911,6.048-2.337,0-4.4-.687-4.4-3.437,0-2.612,2.062-3.437,4.261-3.849s4.811-.412,6.048-1.512v2.749Zm-9.622-8.11c.275-2.887,2.062-3.986,4.811-3.986,2.612,0,4.674.412,4.674,3.574,0,3.024-4.124,2.887-8.66,3.437s-9.072,2.062-9.072,8.11c0,5.5,3.986,7.973,9.072,7.973,3.3,0,6.6-.825,8.935-3.3a8.875,8.875,0,0,0,.55,2.612h7.423c-.687-1.1-.962-3.437-.962-5.911V300.06c0-6.323-6.323-7.56-11.684-7.56-5.911,0-12.1,2.062-12.509,8.935h7.423Z",
    transform: "translate(54.956 6.069)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.193,293.187h-6.873v3.574h-.137c-1.787-3.024-4.4-4.261-7.973-4.261-7.423,0-11.409,6.323-11.409,13.2,0,7.285,3.437,13.334,11.409,13.334a9.15,9.15,0,0,0,7.973-4.124h.137v3.437c0,3.849-1.787,6.6-5.911,6.6-2.612,0-4.811-.962-5.5-3.711h-7.285c.412,6.048,6.461,8.523,11.684,8.523,12.234,0,13.746-7.423,13.746-11.822V293.187ZM335,313.532c-4.4,0-5.911-4.124-5.911-7.973,0-3.986,1.787-7.56,5.911-7.56,4.674,0,6.186,3.849,6.186,8.11,0,3.849-1.924,7.423-6.186,7.423Z",
    transform: "translate(62.486 6.069)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.4,306.123h15.533V299.8H342.4Z",
    transform: "translate(70.203 8.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.1,322.3h25.98v-6.736H363.21V285.6H355.1Z",
    transform: "translate(74.96 3.484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.2,322.3h7.285V285.6H375.2Z",
    transform: "translate(82.49 3.484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7,306.521c0,8.385,5.361,14.021,13.746,14.021s13.746-5.5,13.746-14.021S403.831,292.5,395.446,292.5,381.7,298,381.7,306.521Zm7.285,0c0-4.261,1.512-8.523,6.461-8.523s6.461,4.261,6.461,8.523-1.512,8.523-6.461,8.523c-4.949-.138-6.461-4.4-6.461-8.523Z",
    transform: "translate(84.925 6.069)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.755,293h-7.56l-5.773,18.145h-.137L408.235,293H400.4l9.347,24.881c.825,2.062,0,4.674-2.474,4.949-1.375,0-2.887-.137-4.261-.275V328.6c1.512.137,3.024.275,4.4.275,5.086,0,7.56-1.787,9.072-6.048L427.755,293Z",
    transform: "translate(91.93 6.256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.044,322.3h6.873V285.6h-7.285v13.334h-.137a9.356,9.356,0,0,0-7.973-3.986c-7.835,0-11.822,6.6-11.822,13.746,0,7.285,3.849,14.159,11.959,14.159,3.437,0,6.323-1.237,8.11-4.124h.138V322.3Zm-.138-13.334c0,4.4-1.375,8.523-6.323,8.523-4.536,0-6.461-4.4-6.461-8.523,0-4.4,1.65-8.523,6.461-8.523,4.811.137,6.323,4.261,6.323,8.523Z",
    transform: "translate(98.786 3.484)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHl);
export default __webpack_public_path__ + "static/media/hl.2c5234c0b283f377ba9c53156c3c9210.svg";
export { ForwardRef as ReactComponent };